import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import BadgeSquare from '@/design-system/atoms/BadgeSquare.vue'
import { ref, toRefs, watch } from 'vue'
import { CoreEntityDto } from '@/interfaces/core.interface'
import { useCoreEntityStore } from '@/pinia/coreEntity'

type Props = {
  entityConnectionPath: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EntityConnectionBadge',
  props: {
    entityConnectionPath: {}
  },
  setup(__props: any) {

const props = __props
const coreEntityStore = useCoreEntityStore()
const { entityConnectionPath } = toRefs(props)
const names = ref<string>()

async function getCoreEntityNames(entityConnectionPath: string[]): Promise<string | undefined> {
  if (!entityConnectionPath?.length) {
    return undefined
  }
  let parents: CoreEntityDto[] = []
  for (const entityId of entityConnectionPath) {
    const coreEntity = await coreEntityStore.getCoreEntity(entityId)
    if (coreEntity) {
      parents.push(coreEntity)
    }
  }
  return parents?.map((parent) => parent.displayName).join(', ')
}

watch(
  entityConnectionPath,
  async (newValue) => {
    if (!newValue) return
    const parents = await getCoreEntityNames(newValue)
    if (!parents) return
    names.value = parents
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (names.value)
    ? (_openBlock(), _createBlock(BadgeSquare, {
        key: 0,
        badgeText: names.value,
        grey: true,
        size: "extra-small"
      }, null, 8, ["badgeText"]))
    : _createCommentVNode("", true)
}
}

})